'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { MySoftwaresDataTable } from './-components/MySoftwaresDataTable';
import { MySoftwaresSearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_individual/individual/_profile/my-profile/_layout/softwares/',
)({
  component: MySoftwaresPage,
  validateSearch: zodValidator(MySoftwaresSearchSchema),
});

function MySoftwaresPage() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.myProfile.softwares',
  });
  useDocumentTitle(t('pageTitle'));

  return (
    <div className="flex flex-col gap-4 px-0 md:px-12 pt-4 pb-4 md:py-5 md:flex-1 md:min-h-0">
      <MySoftwaresDataTable />
    </div>
  );
}
